module.exports = "@media screen and (max-width:360px){\n    .a{\n        color:white;\n        font-size:25px !important;\n    }  \n}\n\n.abc{\n    text-align:left;\n    font-size: 23px;\n    font-family: Roboto, Arial, sans-serif;\n    font-weight:bold;\n}\n\n.abcd{\n    text-align:right;\n    font-size: 17px;\n    font-weight:bold;\n    color:rgb(53, 53, 233);\n}\n\n::ng-deep .mat-grid-tile .mat-figure{\n    /* align-items: unset!important; */\n    text-align: right!important;\n}\n\n.set{\n    position: absolute;\n    left: 0;\n}\n"


//////////////////
// WEBPACK FOOTER
// ./src/app/home/home.component.css
// module id = ./src/app/home/home.component.css
// module chunks = main